import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Flex } from '@shared/components/flex';

import { styles } from './CreateNewDrawerFooter.styles';

export interface CreateNewDrawerFooterInterface extends WithStyles<typeof styles> {
  text?: string;
  backArrow?: boolean;
  onBackClick: () => void;
  button?: React.ReactNode | string;
  validationErrorText?: string;
}

const CreateNewDrawerFooterComponent: React.FC<CreateNewDrawerFooterInterface> = ({
  backArrow = true,
  classes,
  text,
  onBackClick,
  validationErrorText,
  button,
}) => {
  return (
    <div className={classes.footerWrapper}>
      <div className={classes.validationError}>{validationErrorText}</div>
      <Flex justifyContent="space-between" className={classes.footerActionsWrap}>
        <div className={classes.text} onClick={onBackClick}>
          {text && backArrow && <ArrowBackIosIcon classes={{ root: classes.backIcon }} />}
          {text}
        </div>
        <div>{button}</div>
      </Flex>
    </div>
  );
};

export const CreateNewDrawerFooter = withStyles(styles)(CreateNewDrawerFooterComponent);
